
import { Checkbox } from 'primereact/checkbox';
import React, {useEffect, useState} from 'react';
import { formatDate } from '../../constants/DateUtil/DateUtil';
import { checkPackageSubscriptionOffer } from '../../services/PaymentOfferManagement/CheckPackageSubscriptionOffer';
import { getStoreLocalData } from '../../utils/localStorage';

const CollectPaymentPackageSubscriptionOfferDefault = ({
  storeCustomerId,
  storeId,
  storeUserId,
  grandTotal,
  onChecked,
  enabledApplySubscriptionWithPackage,
  enabledAutoApplySubscriptionWithPackage,
  orderPackageData
}) => {
  const [selectedItem, setSelectedItem] = useState([]);
  const [selectedItemValue, setSelectedItemValue] = useState(null);
  const [showHide, setShowHide] = useState(false);

  const handleItemPress = () => {
    setShowHide(showHide => !showHide);
  };

  const { storeLocalData } = getStoreLocalData();

  const [subscriptionPackageOfferData, setSubscriptionPackageOfferData] =
    useState([]);

  const fetchSubscriptionPackageOffer = packageSubscriptionData => {
    checkPackageSubscriptionOffer(
      storeId,
      storeCustomerId,
      packageSubscriptionData,
    )
      .then(response => {
        if (!response.data.error) {
          const res = response.data;
          const ResNew = res.map(item => ({
            id: item?.packageOfferSubscriber?.id,
            value: item.discount,
            expireDate: item?.packageOfferSubscriber?.validTo,
            packagePercentage: item?.packageOfferSubscriber?.brandPackageOffer?.value,
            packageName: item?.packageOfferSubscriber?.brandPackageOffer?.name
          }));
          setSubscriptionPackageOfferData(ResNew);
        }
      })
      .catch(err => {
        console.error('Error:', err);
      });
  };

  useEffect(() => {
    const packageSubscriptionData = {
      grandTotal: Math.round(grandTotal),
      storeCustomerId: storeCustomerId,
    };
    fetchSubscriptionPackageOffer(packageSubscriptionData);
  }, [grandTotal]);

  // const handleStatusToggle = itemId => {
  //   // Check if the item is already selected
  //   if (selectedItem.includes(itemId)) {
  //     // If selected, remove it from the list
  //     const updatedItems = selectedItem.filter(id => id !== itemId);
  //     setSelectedItem(updatedItems);
  //   } else {
  //     // If not selected, add it to the list
  //     setSelectedItem([itemId]);
  //   }

  //   // Update the selected value with the last selected item (if any)
  //   setSelectedItemValue(itemId);
    
  // };

  // onChecked({
  //   selectedItemValue: selectedItem,
  // });

  const showPackageSubscriptionMessage = enabledApplySubscriptionWithPackage && orderPackageData?.length > 0 ? true : false;

const handleStatusToggle = itemId => {
  let updatedItems;

  // Check if the item is already selected
  if (selectedItem.includes(itemId)) {
    // If selected, remove it from the list
    updatedItems = selectedItem.filter(id => id !== itemId);
  } else {
    // If not selected, add it to the list
    updatedItems = [itemId];
  }

  // Update the selected items array
  setSelectedItem(updatedItems);

  // Pass the last selected item to onChecked as a single value
  const lastSelectedItem =
    updatedItems.length > 0 ? updatedItems[updatedItems.length - 1] : null;

  onChecked({
    selectedItemValue: lastSelectedItem,
  });

};
  return (
    subscriptionPackageOfferData?.length > 0 && (
      <div
      className="flex-1 px-3 mb-2"
      style={{
        // backgroundColor: "#F6FAFF",
      }}
    >
        <div className={
          "flex flex-1 justify-content-between mx-2 py-2 cursor-pointer"
        }
          onClick={() => handleItemPress()}>
          <div className="flex justify-content-start align-items-center flex-1 ">
            <img
              src={'Laundy_App_Icons_Gifs/SettingIcons/gift.png'}
              resizeMode="cover"
              style={{
              width: 20,
              height: 20,
            }}
            />
            <p className=" text-lg font-medium capitalize ml-2">
              Package Subscription Offer {showPackageSubscriptionMessage && !enabledAutoApplySubscriptionWithPackage && "(* Package Item also added)"}
            </p>
          </div>
          <div >
          {!showHide ? (
            <i
              className="pi pi-angle-down"
              style={{ fontSize: "25px", cursor: "pointer", color: "#777" }}
            ></i>
          ) : (
            <i
              className="pi pi-angle-up"
              style={{ fontSize: "25px", cursor: "pointer", color: "#777" }}
            ></i>
          )}
            
          </div>
        </div>
        <div ></div>

        {showHide && (
          <div
          className=" border-top-2"
          style={{
            borderTopColor: "#C1C9D3",
          }}
        >
            <div className="mt-3 pb-3">
              {subscriptionPackageOfferData.map(item => (
                <div
                      className=" flex my-1 mx-1 border-round-md shadow-4"
                      style={{
                        borderRadius: 5,
                        backgroundImage:
                          "radial-gradient(circle at left top, #FF5F6D, #FFC371)",
                        flex: 1,
                      }}
                    >
                  <div
                    className="flex-row flex justify-content-between align-items-center py-1 px-2"
                    key={item.id}>
                    <p className=" text-lg text-white font-medium capitalize">
                      Discount {storeLocalData?.currencySymbol} {item.value} | {(item.packagePercentage) + "%"}
                    </p>
                    <p className=" text-lg text-white font-medium capitalize">
                      {/* Expiry - {formatDate(item.expireDate)} */}
                      {item.packageName}
                    </p>
                    <Checkbox
                      checked={selectedItem.includes(item.id)}
                      color={
                        selectedItem.includes(item.id) ? '#00A3FF' : '#fff'
                      }
                      onClick={() => handleStatusToggle(item.id)}
                    ></Checkbox>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    )
  );
};

export default CollectPaymentPackageSubscriptionOfferDefault;
